import { Typography } from "@mui/material"

type Props = {}

const SettingsTitle = (props: Props) => {
  return <Typography variant="h4">Settings</Typography>
}

export default SettingsTitle
